<template>
  <v-card flat class="rounded-20">
    <v-card-title class="title-font"> SCAN GAUGE SCAN ALIGNMENT </v-card-title>

    <v-card-text class="text-center mx-auto" style="width: 100%; height: 400px">
      <LoadingSpinner v-if="loading" class="mt-12" />
      <div ref="view"></div>
      <div v-if="selectedOrderSession.reference_number" class="black--text text-body-1">
        REFERENCE NUMBER:
        <span class="font-weight-medium">
          {{ selectedOrderSession.reference_number }}
        </span>
      </div>
    </v-card-text>

    <v-card-text>
      <v-row v-if="showHeatmapColors">
        <v-col>
          <HeatmapScale class="mx-auto mt-3" />
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-text class="pa-0">
      <v-card flat class="rounded-20">
        <v-card-actions>
          <v-switch
            dense
            inset
            label="Show Heatmap"
            v-model="showHeatmapColors"
            :disabled="loading"
            class="ml-10"
          />
          <v-spacer />
          <v-switch
            dense
            inset
            label="Show Tissue"
            v-model="showTissue"
            :disabled="loading"
            class="mr-10"
          />
        </v-card-actions>
        <v-card-text class="text-center">
          <v-btn
            text
            small
            class="btn-primary"
            @click="$emit('toggleViewLibAssociation')"
          >
            <v-icon class="mr-2">$gauge</v-icon>
            START LIBRARY ASSOCIATION
          </v-btn>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import apiClient from "@/lib/ApiClient"
import * as NCFrontend from "@osteon-nexus-connect-lib/nc-frontend"
import HeatmapScale from "./AlignmentScan/HeatmapScale.vue"

export default {
  name: "AlignmentScan",

  props: ["order"],

  components: { HeatmapScale },

  view: null,

  data() {
    return {
      loading: false,
      showHeatmapColors: false,
      showTissue: true
    }
  },

  computed: {
    ...mapGetters(["token", "selectedOrderSession", "cachedNcSession"])
  },

  watch: {
    showHeatmapColors() {
      this.toggleHeatmap()
    },

    showTissue() {
      this.toggleTissue()
    }
  },

  methods: {
    ...mapActions(["setCachedNcSession"]),

    async getNcSession() {
      this.loading = true
      let sessionResponse

      if (this.selectedOrderSession.nc_session_id === this.cachedNcSession?.id)
        sessionResponse = this.cachedNcSession.response
      else {
        sessionResponse = await NCFrontend.ApiClient.sessionGet(
          `${apiClient.instanceUrl}/${apiClient.tenantUid}/validation`,
          this.$axios.defaults.headers.Authorization,
          this.selectedOrderSession.nc_session_id
        )
        this.setCachedNcSession({
          id: this.selectedOrderSession.nc_session_id,
          response: sessionResponse
        })
      }

      if (!this.$refs.view) return

      this.view = NCFrontend.createView("overviewView", this.$refs.view)
      NCFrontend.add(this.view)
      this.view.setVisualisation(
        new NCFrontend.Visualisations.LibraryAssociation(this.view.element, {
          fixedScan: sessionResponse.fixedScan,
          scanAnalysis: sessionResponse.scanAnalysis,
          immediateCase: this.selectedOrderSession.session_type === "immediate"
        })
      )
      this.loading = false
    },

    toggleHeatmap() {
      if (this.showHeatmapColors) {
        this.view.visualisation.showHeatmapColors()
      } else {
        this.view.visualisation.showScoreColors()
      }
    },

    toggleTissue() {
      this.view.visualisation.setScanTissueVisible(this.showTissue)
    }
  },

  mounted() {
    this.getNcSession()
  }
}
</script>
